"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryData = useQueryData;
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const react_use_1 = require("react-use");
const queries_registry_1 = require("./queries-registry");
const selectors_1 = require("./selectors");
// TODO - currently it is required for queryKey to be static and never change
// once subscribed. Let's see if it makes sense.
const queryStateFallback = {};
function useQueryData(queryKey) {
    const queryClient = (0, react_query_1.useQueryClient)();
    const queryCache = queryClient.getQueryCache();
    const queryState = (0, selectors_1.useSharedQuerySelector)(queryKey) || queryStateFallback;
    const unsubscribe = (0, react_1.useMemo)(
    // queryCache instance won't change, as we do not change query client instances after the app start
    // long-living sessions with dead tabs are still in question
    () => queries_registry_1.QueriesRegistry.subscribe(queryCache, queryKey), []);
    (0, react_use_1.useUnmount)(() => {
        unsubscribe();
    });
    return queryState;
}
